import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Pressable, StyleSheet, } from 'react-native';
import { theme } from '@xbto/design-system';
import { TextBody } from '../text';
import { Icon } from '../icon';
export const Button = forwardRef(({ label, icon, variant = 'primary', size = 'lg', disabled, fullWidth, onPress, style, }, ref) => {
    let textColor = 'primary';
    switch (variant) {
        case 'secondary':
        case 'success':
            textColor = 'inverse';
            break;
        case 'error':
            textColor = 'error';
            break;
        default:
            break;
    }
    const iconOnly = !!icon && !label;
    return (_jsxs(Pressable, { ref: ref, onPress: onPress, style: ({ pressed, hovered, focused }) => [
            $.pressable,
            fullWidth && $.fullWidth,
            $sizes[size],
            iconOnly && $.iconOnly,
            $variants[variant],
            !disabled && focused && $focused[variant],
            !disabled && hovered && $hovered[variant],
            !disabled && pressed && $pressed[variant],
            disabled && $.disabled,
            iconOnly && size === 'sm' && $.iconOnlySmall, // TODO(Benoit): All icon buttons should be squared imo but for now just specific use case.
            style,
        ], disabled: disabled, children: [label && (_jsx(TextBody, { em: true, small: size === 'xs', color: textColor, lhFull: true, children: label })), icon && (_jsx(Icon, { name: icon, color: textColor, size: size === 'xs' ? 'xs' : 'sm' }))] }));
});
const $ = StyleSheet.create({
    pressable: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: Number(theme.radius.sm),
        columnGap: theme.spacing['1'],
        outline: 'none',
        outlineStyle: 'none',
    },
    iconOnly: {
        paddingHorizontal: theme.spacing['2'],
    },
    iconOnlySmall: {
        minHeight: 32,
        width: 32,
        height: 32,
        paddingHorizontal: 0,
    },
    fullWidth: { flexGrow: 1 },
    disabled: {
        opacity: 0.5,
    },
});
const $sizes = StyleSheet.create({
    xs: {
        minHeight: theme.button.size.xs,
        paddingHorizontal: theme.spacing['2'],
    },
    sm: {
        minHeight: theme.button.size.sm,
        paddingHorizontal: theme.spacing['3'],
    },
    base: {
        minHeight: theme.button.size.base,
        paddingHorizontal: theme.spacing['4'],
    },
    lg: {
        minHeight: theme.button.size.lg,
        paddingHorizontal: theme.spacing['4'],
    },
});
const $variants = StyleSheet.create({
    primary: { backgroundColor: theme.color.button.primary.default },
    secondary: { backgroundColor: theme.color.button.secondary.default },
    tertiary: { backgroundColor: theme.color.button.tertiary.default },
    success: { backgroundColor: theme.color.button.success.default },
    error: { backgroundColor: theme.color.button.error.default },
    clear: {
        backgroundColor: 'transparent',
        borderWidth: 1,
        borderColor: theme.color.border.primary,
    },
    ghost: {
        backgroundColor: 'transparent',
        borderWidth: 0,
    },
});
const $pressed = StyleSheet.create({
    primary: { backgroundColor: theme.color.button.primary.pressed },
    secondary: { backgroundColor: theme.color.button.secondary.pressed },
    tertiary: { backgroundColor: theme.color.button.tertiary.pressed },
    success: { backgroundColor: theme.color.button.success.pressed },
    error: { backgroundColor: theme.color.button.error.pressed },
});
const $hovered = StyleSheet.create({
    primary: { backgroundColor: theme.color.button.primary.hover },
    secondary: { backgroundColor: theme.color.button.secondary.hover },
    tertiary: { backgroundColor: theme.color.button.tertiary.hover },
    success: { backgroundColor: theme.color.button.success.hover },
    error: { backgroundColor: theme.color.button.error.hover },
});
const $focused = StyleSheet.create({
    primary: { backgroundColor: theme.color.button.primary.focused },
    secondary: { backgroundColor: theme.color.button.secondary.focused },
    tertiary: { backgroundColor: theme.color.button.tertiary.focused },
    success: { backgroundColor: theme.color.button.success.focused },
    error: { backgroundColor: theme.color.button.error.focused },
});
